import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PaymentMethod from "./PaymentMethod";

const PaymentMethodPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { practitionerRoleId } = useParams<{ practitionerRoleId: string }>();
  const teleconsultationId = location.state?.teleconsultationId || 0;
  const pertanyaan = location.state?.pertanyaan || null;
  const { selectedPayment, selectedVoucher } = location.state || {};

  return (
    <PaymentMethod
      defaultPayment={selectedPayment}
      onSelect={(payment) => {
        navigate(`/checkout-teleconsultation/${practitionerRoleId}`, {
          state: {
            selectedPayment: payment,
            selectedVoucher,
            teleconsultationId,
            pertanyaan,
          },
        });
      }}
    />
  );
};

export default PaymentMethodPage;
